import React, { useState } from "react";
import { Button, Menu, MenuItem } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

export default function MenuActionsButton({ selection, itemsSelected }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    return (
        <div>
            <Button
                variant="contained"
                endIcon={<ArrowDropDownIcon />}
                onClick={(e) => setAnchorEl(e.currentTarget)}
                sx={{ minHeight: 36, px: 1.75 }}
            >
                Actions
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
                <MenuItem onClick={() => { setAnchorEl(null); selection('pos refresh'); }}>
                    POS refresh
                </MenuItem>
                <MenuItem onClick={() => { setAnchorEl(null); selection('addCatalog'); }}>
                    Add catalog item
                </MenuItem>
                <MenuItem
                    disabled={!itemsSelected?.length}
                    onClick={() => { setAnchorEl(null); selection('copy recipe'); }}
                >
                    Copy recipe
                </MenuItem>
            </Menu>
        </div>
    );
}
